import { StateProvider } from '@uirouter/angularjs'
import angular from 'angular'

import saleTemplate from '../../templates/current-sale/sale.html'
import saleSummaryTemplate from '../../templates/current-sale/sale-summary.html'
import reactSummaryPanelTemplate from '../../templates/current-sale/react-summary-panel.html'
import reactPaymentPanelTemplate from '../../templates/current-sale/react-payment-panel.html'
import paymentPanelTemplate from '../../templates/current-sale/payment-panel.html'
import paymentTemplate from '../../templates/current-sale/payment.html'
import saleConfirmationTemplate from '../../templates/current-sale/sale-confirmation.html'
import indexTemplate from '../../templates/current-sale/index.html'
import { ROUTES, STATES } from '../../../lib/routes'
import { getFeatureFromCache } from '../util/feature-cache'
import {
  REACT_CONFIRMATION_PANEL,
  REACT_PAYMENT_PANEL,
  REACT_SALE_COMPONENT,
  REACT_SUMMARY_PANEL,
} from '../constants'

/**
 * =======================================
 * ROUTES CONFIG - CURRENT SALE
 * =======================================
 *
 * @module webregister.routes.current-sale
 */
function CurrentSaleRoutesConfig($stateProvider: StateProvider) {
  const ffReactSummaryPanelEnabled = getFeatureFromCache(REACT_SUMMARY_PANEL)
  const ffReactPaymentPanelEnabled = getFeatureFromCache(REACT_PAYMENT_PANEL)
  const ffReactSaleConfirmationEnabled = getFeatureFromCache(
    REACT_CONFIRMATION_PANEL
  )
  const ffReactSaleRootEnabled = getFeatureFromCache(REACT_SALE_COMPONENT)

  /**
   * =======================================
   * VIEWS
   * =======================================
   */
  const views = {
    workspace: {
      template:
        '<react-workspace-component class="wr-current-sale-panel-content"></react-workspace-component>',
    },
    sale: ffReactSaleRootEnabled
      ? {
          template:
            '<react-sale-root-component class="wr-current-sale-panel-content"></react-sale-root-component>',
        }
      : {
          controller: 'SaleCtrl',
          controllerAs: 'saleCtrl',
          template: saleTemplate,
        },
    saleSummary: ffReactSummaryPanelEnabled
      ? { template: reactSummaryPanelTemplate }
      : {
          controller: 'SaleSummaryCtrl',
          controllerAs: 'saleSummaryCtrl',
          template: saleSummaryTemplate,
        },
    paymentPanel: {
      template: paymentPanelTemplate,
    },
    payment: ffReactPaymentPanelEnabled
      ? { template: reactPaymentPanelTemplate }
      : {
          controller: 'PaymentCtrl',
          controllerAs: 'paymentCtrl',
          template: paymentTemplate,
        },
    saleConfirmation: ffReactSaleConfirmationEnabled
      ? {
          template:
            '<react-confirmation-panel class="payment-panel--action"></react-confirmation-panel>',
        }
      : {
          controller: 'SaleConfirmationCtrl',
          controllerAs: 'saleConfirmationCtrl',
          template: saleConfirmationTemplate,
        },
  }

  /**
   * =======================================
   * STATES
   * =======================================
   */
  $stateProvider
    .state(STATES.CURRENT_SALE, {
      abstract: true,
      template: indexTemplate,
    })
    /*
     * View layout of the current-sale.sale state
     * |--|--------------------------------------|
     * |n |             current-sale             |
     * |a |                                      |
     * |v | |---------------| |----------------| |
     * |  | | current-sale- | | current-sale-  | |
     * |  | | workspace     | | summary        | |
     * |  | |               | |                | |
     * |  | |               | |                | |
     * |  | |               | |                | |
     * |  | |               | |                | |
     * |  | |---------------| |----------------| |
     * |--|--------------------------------------|
     */
    .state(STATES.SALE, {
      url: ROUTES.SALE,
      views: {
        'current-sale-workspace': views.workspace,
        'current-sale-summary': views.sale,
      },
      params: {
        // The sale (or ID thereof) to load (e.g. retrieve a parked/on account/layby sale or load a return)
        sale: null,
        // The action to perform once the sale is loaded (e.g. pay opens the payment dialog)
        action: null,
        closeAfterComplete: false,
        quoteId: null,
      },
    })
    /*
     * View layout of the current-sale.payment-panel state
     * |--|-------------------------------|
     * |n |         current-sale          |
     * |a |                               |
     * |v | |---------------------------| |
     * |  | |        payment-panel      | |
     * |  | | |----------| |----------| | |
     * |  | | | payment- | | payment- | | |
     * |  | | | panel-   | | panel-   | | |
     * |  | | | summary  | | action   | | |
     * |  | | |          | |          | | |
     * |  | | |----------| |----------| | |
     * -----------------------------------|
     */
    .state(STATES.PAYMENT_PANEL, {
      abstract: true,
      views: {
        'payment-panel': views.paymentPanel,
      },
    })
    .state(STATES.PAYMENT, {
      params: {
        lspayQuickPaySelected: false,
      },
      views: {
        'payment-panel-summary': views.saleSummary,
        'payment-panel-action': views.payment,
      },
    })
    .state(STATES.SALE_CONFIRMATION, {
      url: ROUTES.SALE_CONFIRMATION,
      views: {
        'payment-panel-summary': views.saleSummary,
        'payment-panel-action': views.saleConfirmation,
      },
    })
}

angular.module('webregister.routes').config(CurrentSaleRoutesConfig)
